import apiHandler from "../core/apiHandler";

const certificatePdfApi = apiHandler("pdf/certificate");
export default certificatePdfApi;
